import React                                    from 'react'

import {
   Grid,
   TextField,
}                                               from '@material-ui/core'
import PropTypes                                from 'prop-types'

/* This componnent makes use of an empty tag since even a <div> </div> was causing issues with page placement. */

const SearchUserIdUsernameComponent = ( { handleSearch, handleSelectFromSearch, label, name, setCurrentSearch, userId } ) => {
   return (
      <>
         <Grid item xs={2}>
            <TextField label='search' onFocus={() => {setCurrentSearch(label)}} variant='outlined' onChange={handleSearch} />
         </Grid>
         <Grid item xs={1}>
            <TextField label='userId' value={userId} variant='outlined' />
         </Grid>
         <Grid item xs={3} >
            <TextField label={label} value={name} variant='outlined' style={{width: '100%', marginLeft: '0.3rem'}} />
         </Grid>
      </>
   )
}

SearchUserIdUsernameComponent.propTypes = {
   handleSearch:                                PropTypes.func,
   handleSelectFromSearch:                      PropTypes.func,
   label:                                       PropTypes.string,
   name:                                        PropTypes.string,
   setCurrentSearch:                            PropTypes.func,
   userId:                                      PropTypes.string
}

export default SearchUserIdUsernameComponent
